import React from 'react';
import PropTypes from 'prop-types';
import ChargeModalButton from './ChargeModalButton';
import insertCcImage from '../../../../../images/insert-cc.svg';

const ReaderChargeButton = ({ onClick, disabled }) => (
  <ChargeModalButton onClick={onClick} disabled={disabled} image={insertCcImage}>
    Swipe / Insert CC
  </ChargeModalButton>
);
ReaderChargeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ReaderChargeButton;
